import React, { useEffect } from 'react'
import { Views } from '../../views'
import { useSelector, useDispatch } from 'react-redux'
import { PAYMENT_HISTORY } from '../../redux/actions/type'
import { isEmpty } from 'lodash'

const PaymentHistory = () => {
    const { PaymentHistoryView } = Views
    const dispatch = useDispatch()
    const keycloak = useSelector(state => state.keycloak)
    useEffect(() => {
        if (!isEmpty(keycloak) && keycloak.authenticated) {
            dispatch({
                type: PAYMENT_HISTORY
            })
        }
    }, [dispatch, keycloak])
    if (!keycloak.authenticated) {
        window.location.href = '/portal'
    } else {
        return <PaymentHistoryView />
    }
}

export default PaymentHistory